export const createClientRequestId=(prefix='request')=>`${prefix}_${(typeof window!=='undefined' && window.crypto?.randomUUID?.()) || `${Date.now()}_${Math.random().toString(36).slice(2)}`}`;
